const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || "/api";

export type TradeType = "buy" | "sell";

export interface TradingHistoryFilters {
  token?: string | number | null;
  wallet?: string | null;
  type?: TradeType | "all" | null;
  order?: "asc" | "desc";
  limit?: number;
  offset?: number;
}

export interface TradingHistoryItem {
  id: number;
  userWallet: string;
  username: string;
  usernameShort: string | null;
  tokenId: number | null;
  tokenSymbol: string | null;
  transactionType: TradeType;
  suiAmount: number | null;
  tokenAmount: number | null;
  pricePerToken: number | null;
  transactionHash: string | null;
  suiExplorerUrl: string | null;
  status: string | null;
  createdAt: string;
}

export interface TradingHistoryResponse {
  success: boolean;
  transactions: TradingHistoryItem[];
  meta: {
    total: number;
    limit: number;
    offset: number;
    order: "asc" | "desc";
    filters: Required<Pick<TradingHistoryFilters, "token" | "wallet" | "type">>;
    tokens: string[];
  };
  error?: string;
}

export async function fetchTradingHistory(filters: TradingHistoryFilters = {}): Promise<TradingHistoryResponse> {
  const params = new URLSearchParams();

  const resolvedOrder = (filters.order ?? "desc").toLowerCase() === "asc" ? "asc" : "desc";
  const resolvedLimit = Number.isFinite(filters.limit as number) ? Number(filters.limit) : 25;
  const resolvedOffset = Number.isFinite(filters.offset as number) ? Number(filters.offset) : 0;

  params.set("order", resolvedOrder);
  params.set("limit", Math.max(1, Math.min(200, resolvedLimit)).toString());
  params.set("offset", Math.max(0, resolvedOffset).toString());

  if (filters.token !== null && filters.token !== undefined && filters.token !== "") {
    params.set("token", String(filters.token));
  }

  if (filters.wallet) {
    params.set("wallet", filters.wallet.trim());
  }

  if (filters.type && filters.type !== "all") {
    params.set("type", filters.type);
  }

  const query = params.toString();
  const url = query.length
    ? `${API_BASE_URL}/api/trading-history?${query}`
    : `${API_BASE_URL}/api/trading-history`;

  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to load trading history (${response.status})`);
  }

  const payload = (await response.json()) as TradingHistoryResponse;
  if (!payload.success) {
    throw new Error(payload.error ?? "Failed to load trading history");
  }

  return payload;
}
